exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".studentInfoContainer .responseUserLine .owlConstraints{display:inline-block;vertical-align:middle}.studentInfoContainer .editedInfo{color:orange}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/responses/student_activity_info_line.scss
// module id = 1540
// module chunks = 0